/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Telegram_Mock_Lcd_ReadyInputs */

const tr_landing_telegram_mock_lcd_ready = /** @type {(inputs: Landing_Telegram_Mock_Lcd_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`✓ hazır`)
};

const en_landing_telegram_mock_lcd_ready = /** @type {(inputs: Landing_Telegram_Mock_Lcd_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`✓ ready`)
};

const de_landing_telegram_mock_lcd_ready = /** @type {(inputs: Landing_Telegram_Mock_Lcd_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`✓ bereit`)
};

const ru_landing_telegram_mock_lcd_ready = /** @type {(inputs: Landing_Telegram_Mock_Lcd_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`✓ готов`)
};

/**
* | output |
* | --- |
* | "✓ ready" |
*
* @param {Landing_Telegram_Mock_Lcd_ReadyInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_telegram_mock_lcd_ready = /** @type {((inputs?: Landing_Telegram_Mock_Lcd_ReadyInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Telegram_Mock_Lcd_ReadyInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_telegram_mock_lcd_ready(inputs)
	if (locale === "de") return de_landing_telegram_mock_lcd_ready(inputs)
	if (locale === "ru") return ru_landing_telegram_mock_lcd_ready(inputs)
	return tr_landing_telegram_mock_lcd_ready(inputs)
});